import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = { hasError: false };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="wrap section">
        <span className="eyebrow">Something broke</span>
        <h1 style={{ fontSize: 'var(--t-h2)', margin: '18px 0 14px' }}>
          This page didn&rsquo;t load properly.
        </h1>
        <p className="lede">
          That&rsquo;s our fault, not yours. Reload the page, and if it keeps happening
          we&rsquo;d genuinely like to know:{' '}
          <a href="mailto:hello@blockworks.dev" style={{ color: 'var(--accent)' }}>
            hello@blockworks.dev
          </a>
          .
        </p>
      </div>
    );
  }
}

export default ErrorBoundary;
